import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import type { CommunityProfile, DataRegion } from '@lebinatikra/shared-types';

interface CommunityForm {
  name: string;
  slug: string;
  profile: CommunityProfile;
  data_region: DataRegion;
  rav_kehilla_user_id?: string | null;
}

const PROFILES: CommunityProfile[] = [
  'hasidic',
  'litvish',
  'sephardic',
  'modern_orthodox',
  'custom',
];
const REGIONS: DataRegion[] = ['il', 'eu', 'us'];

export function CommunityCreate() {
  const { t } = useTranslation();
  const { formProps, saveButtonProps } = useForm<CommunityForm>();

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item name="name" label={t('common.name')} rules={[{ required: true, max: 200 }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="slug"
          label={t('fields.slug')}
          rules={[{ required: true, pattern: /^[a-z0-9-]+$/ }]}
        >
          <Input dir="ltr" />
        </Form.Item>
        <Form.Item name="profile" label={t('fields.profile')} rules={[{ required: true }]}>
          <Select options={PROFILES.map((p) => ({ value: p, label: p }))} />
        </Form.Item>
        <Form.Item name="data_region" label={t('fields.data_region')} rules={[{ required: true }]}>
          <Select options={REGIONS.map((r) => ({ value: r, label: r }))} />
        </Form.Item>
        <Form.Item name="rav_kehilla_user_id" label={t('fields.rav_kehilla_user_id')}>
          <Input dir="ltr" placeholder="uuid" />
        </Form.Item>
      </Form>
    </Create>
  );
}
